import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ShareMenu from '@/components/ShareMenu/ShareMenu';
import Forward from '@/images/Forward.svg';
import { useAnalytics } from '@/services/analytics';
import { IAgent } from '@d-id/types';
import { Button } from '@de-id/ui-components';
import styled from '@emotion/styled';
import { useState } from 'react';

const StyledButton = styled(Button)`
    background-color: ${({ theme }) => theme.colors.white};
`;

interface Props {
    template: IAgent;
}

export const ShareTemplateButton = ({ template }: Props) => {
    const [shareAnchorEl, setShareAnchorEl] = useState<HTMLButtonElement | null>(null);
    const mixpanel = useAnalytics();

    const handleShareTemplate = () => {
        mixpanel?.track('agent-share', { event: 'click', from: 'agent-template', template: template.id });
    };

    return (
        <>
            <StyledButton
                color="outlined"
                onClick={e => setShareAnchorEl(e.currentTarget)}
                startIcon={<MaskedIcon src={Forward} size="20px" />}>
                Share
            </StyledButton>

            <ShareMenu
                id="agent-template-share-menu"
                createShareUrl={() => window.location.href}
                handleShare={handleShareTemplate}
                open={!!shareAnchorEl}
                anchorEl={shareAnchorEl}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: -10, horizontal: -20 }}
                onClose={() => {
                    setShareAnchorEl(null);
                }}
            />
        </>
    );
};
